// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "terasku-bd171.firebaseapp.com",
  projectId: "terasku-bd171",
  storageBucket: "terasku-bd171.firebasestorage.app",
  messagingSenderId: "293713809881",
  appId: "1:293713809881:web:2c3ba122fab470efdcc9c8",
  measurementId: "G-KX78J7MV38",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
